module.exports = __webpack_public_path__ + "img/down-payment-qr.23150afe.jpg";